
<div class="modal-content">
    <slot />
</div>
